//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import dayjs from 'dayjs';
export default {
  name: 'PerformanceCalendar',
  props: {
    calendarModuleVO: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      calendarNumber: ''
    };
  },
  mounted: function mounted() {
    this.initData();
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_q585vlfq_mv'
    });
  },
  methods: {
    initData: function initData() {
      var _this$calendarModuleV;
      if ((_this$calendarModuleV = this.calendarModuleVO) !== null && _this$calendarModuleV !== void 0 && _this$calendarModuleV.calendarNumber) {
        var _this$calendarModuleV2;
        this.calendarNumber = dayjs((_this$calendarModuleV2 = this.calendarModuleVO) === null || _this$calendarModuleV2 === void 0 ? void 0 : _this$calendarModuleV2.calendarNumber).date();
      }
    },
    handleClickCard: function handleClickCard() {
      var _this$calendarModuleV3;
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_q585vlfq_mc',
        needTag: true
      });
      var url = (_this$calendarModuleV3 = this.calendarModuleVO) === null || _this$calendarModuleV3 === void 0 ? void 0 : _this$calendarModuleV3.jumpUrl;
      Drip.redirect(url);
    }
  }
};